import { addMinutes, isAfter } from 'date-fns';
import { Timezone } from '../types';

// Map from response body
// If the timezone is missing, the datetime is interpreted in the user time zone. This will happen when you create/edit a exercise, because you show and edit the literal datetime (timezoneless).
// If the timezone is appended (it should be 'Z'), the datetime is interpreted in that time zone. This will happen when you display an exercise.
export function parseTime<T extends undefined | { startTime?: string; endTime?: string; [key: string]: unknown }>(
  item: T,
) {
  return (
    item && {
      ...item,
      endTime: item.endTime ? new Date(item.endTime) : undefined,
      startTime: item.startTime ? new Date(item.startTime) : undefined,
    }
  );
}

export const parseAsUtc = (date: Date) => {
  const userOffset = date.getTimezoneOffset();
  return addMinutes(date, userOffset);
};

export const parseOffsetMinutes = (tzOffset: string) => {
  const matches = tzOffset?.match(/([+-]?)(\d\d):(\d\d):(\d\d)?/); // "-07:00:00"
  const [, sign, hours, minutes, seconds] = matches ?? [null, '+', 0, 0, 0];

  return (sign === '-' ? -1 : 1) * (+hours * 60 + +minutes + +seconds / 60);
};

export const validateTimeInFuture = (value: Date | null, timezone?: Timezone) => {
  if (value === null) return true;

  const tzOffset = timezone?.offset;
  const userOffsetMinutes = new Date(value).getTimezoneOffset();
  const offsetMinutes = tzOffset ? userOffsetMinutes + parseOffsetMinutes(tzOffset) : 0;

  return isAfter(addMinutes(value, -offsetMinutes), new Date()) || 'The time should be in the future';
};
